(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-founder-log"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ws-founder-portrait')) {
    customElements.define('ws-founder-portrait', class extends HTMLElement {
      connectedCallback() {
        if (!this.classList.contains('ws-founder__media--reveal') || this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        const toggle = () => {
          const showPhoto = !this.classList.contains('is-photo');
          this.classList.toggle('is-photo', showPhoto);
          this.setAttribute('aria-pressed', String(showPhoto));
          this.setAttribute(
            'aria-label',
            showPhoto ? 'Show the illustrated founder portrait' : 'Show the real founder photograph'
          );
        };

        this.addEventListener('click', toggle);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggle();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-order-map"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ws-order-map-motion')) {
  customElements.define('ws-order-map-motion', class extends HTMLElement {
    connectedCallback() {
      this.removeAttribute('data-active');
      this.inView = false;
      if (!('IntersectionObserver' in window)) return;
      this.syncMotion = () => this.toggleAttribute('data-active', this.inView && !document.hidden);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries.some((entry) => entry.isIntersecting);
        this.syncMotion();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.syncMotion);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.syncMotion) document.removeEventListener('visibilitychange', this.syncMotion);
      this.removeAttribute('data-active');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
